import Mixin from './utils/mixin';
import Stack from './App.vue';

/*
 * The stacking system provides an easy solution to quickly stack components
 * with various content in a flex container. The content is linked to the URL
 * so when navigating the site the tree can be kept if the page is re-entered.
 *
 * Since this was inspired by vue-router, some functionality / code has been copied.
 */
export default function install(Vue) {
  // Add to prorotype so our mixins work with updates
  Vue.util.defineReactive(Vue.prototype, '$stack', {});

  // Add helper functions
  Vue.mixin(Mixin);

  // Add as a global component
  Vue.component('stack', Stack);

  // Require global APIs
  require('../api');
}



// WEBPACK FOOTER //
// ./resources/assets/js/view-stack/index.js